import { MetricsKind } from "../types";
import { SIMPLE_SUM } from "./simple-sum";
import { roundValue, safeParseFloat } from "lib/number";

export const AVERAGE_UNITS = ({ factoryOptions, getterParams }) => {
    const { doors } = factoryOptions;
    // Get plan row units
    const unitsFactoryOptions = { ...factoryOptions, metric: { kind: MetricsKind.AVERAGE_UNITS } };
    const unitsPlanRows = SIMPLE_SUM({ factoryOptions: unitsFactoryOptions, getterParams });

    const averageUnits = safeParseFloat(unitsPlanRows / doors.length, 0);
    return roundValue(averageUnits, 1);
};
